import { z } from "zod";

const initializeTokenSchema = z.object({
  access_token: z.string(),
  citizen_firstname: z.string(),
  citizen_lastname: z.string(),
  caseworker: z.boolean().nullish(),
  read_only: z.boolean().nullish(),
});

export const initializeTokenResponseSchema = z
  .object({
    initialToken: initializeTokenSchema,
  })
  .strict();

export type InitializeToken = z.infer<typeof initializeTokenSchema>;
export type InitializeTokenResponse = z.infer<typeof initializeTokenResponseSchema>;
